import { createContext, useContext } from 'react';

// A interface continua a mesma
interface WebSocketContextData {
  connectionStatus: 'connected' | 'disconnected' | 'connecting' | 'error';
  sendMessage: (message: object) => void;
}

// Criamos o contexto com um valor padrão para evitar erros
// A função sendMessage agora tem uma implementação padrão para o caso de erro.
export const WebSocketContext = createContext<WebSocketContextData>({
  connectionStatus: 'disconnected',
  sendMessage: () => {
    console.error('WebSocketContext não foi inicializado corretamente.');
  },
});

// O hook para usar o contexto permanece o mesmo
export function useWebSocket(): WebSocketContextData {
  const context = useContext(WebSocketContext);
  return context;
}